
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': 'Alfinete',
	'find_label': 'Localizar',
	'findCancelLabel': 'Cancelar',
	'dataPaneLabel': 'Dados',
	'sourcePaneLabel': 'Origens selecionadas',
	'sourcePaneContentLabel': 'Selecionar uma origem',
	'emptySourcePaneTitle': 'Selecionar uma origem',
	'emptySourcePaneCaption': 'Clique em Selecionar uma origem para incluir dados a serem usados para construir um painel.',
	'addDataSource': 'Selecionar uma origem',
	'addDataDashboardCoachMarkContents': 'Arrastar e soltar dados a partir do painel de dados em seu painel.',
	'addDataStoryCoachMarkContents': 'Arrastar e soltar dados a partir do painel de dados em sua história.',
	'addDataCoachMarkTitle': 'Incluir dados',
	'selectSourcesText': 'Selecione e inclua uma origem de dados para construir seu %{app}.',
	'selectSourcesLabel': 'Selecionar uma origem',
	'errorSourcesTitle': 'Falha ao carregar a árvore de dados',
	'errorLoadingDataSources': 'Ocorreu um erro durante o carregamento da lista de conjunto de dados',
	'errorLoadingDataTree': 'Ocorreu um erro ao carregar a árvore',
	'dataSetPaneLastUpdated': 'Última atualização: %{date}',
	'dataSourcePaneDateUnknown': 'Desconhecido',
	'moreTitle': 'Mais',
	'backLabel': 'Voltar',
	'addDataSourceDialogTitle': 'Selecionar uma origem',
	'addDataSourceDialogButtonLabel': 'Incluir',
	'dlg_use': 'Usar',
	'dlg_RelinkDataSourceTitle': 'Substituir o conjunto de dados "%{dataSourceName}" por...',
	'propertiesDialogTitle': 'Propriedades',
	'loadingMetadata': 'Carregando metadados',
	'missingDataSetData': 'Os dados para este conjunto de dados não estão disponíveis. Atualize o conjunto de dados ou entre em contato com o administrador para acessar a origem.',
	'errorLoadingSource': 'Os metadados de "%{sourceName}" não foram carregados. Entre em contato com seu administrador para obter detalhes.',
	'errorMessageTitle': 'Erro',
	'calculation_navigation_in_use': 'A exclusão de cálculos, filtros ou caminhos de navegação invalida todas as visualizações que referenciam o item excluído. Tem certeza de que deseja excluir?',
	'delete_confirm': 'Confirmar Exclusão',
	'previewUnavailable': 'A bandeja de dados e os filtros globais estão indisponíveis para esse tipo de pacote.',
	'contextualGridTabName': 'Visualização de dados',
	'DATA_TRAY_no_data_text': 'Você não tem atualmente nenhum dado',
	'contextualGridMenuLabel': 'Menu de Visualização de Dados',
	'contextualGridExport': 'Exportar',
	'nullValueText': 'Nulo',
	'forecastDetailsTabName': 'Detalhes estatísticos da previsão',
	'forecastDetailsModelLabel': 'Modelo',
	'forecastDetailsQualityMetricLabel': 'Medidas de precisão',
	'forecastDetailsSmoothingCoefLabel': 'Parâmetros',
	'forecastDetailsDiagnostics': 'Diagnóstico',
	'forecastDetailsForecastLabel': 'Previsto',
	'forecastDetailsStatusLabel': 'Status',
	'forecastDetailsAccuracyPercentLabel': 'Exatidão %',
	'forecastDetailsTrendLabel': 'Tendência',
	'forecastDetailsSeasonLabel': 'Sazonalidade',
	'forecastDetailsSeasonalPeriodLabel': 'Período sazonal',
	'forecastDetailsAlphaLabel': 'Alfa',
	'forecastDetailsBetaLabel': 'Beta',
	'forecastDetailsGammaLabel': 'Gama',
	'forecastDetailsPhiLabel': 'Fi',
	'forecastDetailsMissingCount': 'Contagem ausente',
	'forecastDetailsSeriesLengthLabel': 'Comprimento da série',
	'forecastDetailsIgnoredPeriods': 'Períodos ignorados',
	'forecastDetailsTrendStrength': 'Força de tendência',
	'forecastDetailsSeasonalityStrength': 'Força de sazonalidade',
	'forecastDetailsTimeDeltaUnit': 'Intervalo de data/hora',
	'forecastDetailsNotes': 'Observações'
});
